<template lang="pug">
  lei-modal.export-modal(:title="title" size="sm" :close-with-overlay="false" @close="closeExportModal")
    .container.d-block
      p.label You can export search results up to 5000 LEI Records. Please choose whether you want to:
      ul
        li.mb-2
          p.mb-1.description Download the <span class='default-bold'>5000</span> best matching LEI Records
            | &nbsp;for your search query:
          lei-btn(type="turquoise-keyline" @click='exportSearchResults(exportFormat)' size="sm" fill) Download

        li(v-if='isExcelFormat')
          p.mb-1.description Download the <span class='default-bold'>complete set</span> of LEI Records:
          lei-btn(type="turquoise-keyline" @click='exportFullFile' size="sm" fill) Download

        li(v-else)
          p.description Full Excel export is not available as Excel supports not more than 1.048.576 rows.

</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters, } from 'vuex'
import { TOGGLE_EXPORT_MODAL, } from '@/store/modules/search/mutations-types'
import { TOGGLE_LOADING, } from '@/store/mutations-types'
import LeiModal from '@/components/lei-components/LeiModal'
import LeiBtn from '@/components/lei-components/LeiBtn'

export default {
  name: 'ExportModal',
  components: {
    LeiBtn,
    LeiModal,
  },
  computed: {
    title () {
      return this.screenWidth > 500
        ? `LEI Search Result Export to ${(this.exportFormat).toUpperCase()}`
        : `Export to ${(this.exportFormat).toUpperCase()}`
    },
    isExcelFormat () {
      return this.exportFormat !== 'xlsx'
    },

    ...mapState('search', [ 'exportFormat', ]),
    ...mapGetters([ 'screenWidth', ]),
  },
  methods: {
    closeExportModal () {
      this.toggleModal(false)
    },

    ...mapActions('search', [ 'exportFullFile', 'exportSearchResults', ]),
    ...mapMutations('search', {
      toggleModal: TOGGLE_EXPORT_MODAL,
    }),
    ...mapMutations({
      toggleLoading: TOGGLE_LOADING,
    }),
  },
}
</script>

<style scoped lang="stylus">
  @import "../../assets/styles/variables.styl"

  .d-block
    display: block

  .label
    font-size: 1rem
    color: $default-color-bold
    font-weight: 600
    margin-bottom: 2rem
    display: inline-flex
    line-height: 1.25

  .mb-2
    margin-bottom: 2rem

  .mb-1
    margin-bottom: .8rem

</style>



// WEBPACK FOOTER //
// src/components/modals/ExportModal.vue